import classnames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import { chainDecorators, memoized } from '../../utils/ReactUtils'
import Marquee from "react-fast-marquee";


import styles from './styles'


const decorators = [
  memoized,
]

function HorizontalTextAnimated({ className, text, marqueeProps }) {
  return (
    <>
      <span className={classnames('horizontal', className)}>
        <Marquee {...marqueeProps}>
          <p className='text' dangerouslySetInnerHTML={{ __html: text.replaceAll('  ', '&nbsp;&nbsp;') }} />
        </Marquee>
        <style jsx>{styles}</style>
      </span>
    </>
  )
}

HorizontalTextAnimated.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  marqueeProps: PropTypes.shape(Marquee.propTypes)
}

HorizontalTextAnimated.defaultProps = {
  className: null,
  text: null,
  direction: null,
  marqueeProps: null,
}

HorizontalTextAnimated = chainDecorators(decorators, HorizontalTextAnimated)

export default HorizontalTextAnimated
